import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { AlertService } from 'src/app/services/common/alert.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { WishListService } from 'src/app/services/wishlist.service';
import { CouponGenerateComponent } from '../shared/common/coupon-generate/coupon-generate.component';
import { ShareCampaignComponent } from '../shared/common/share-campaign/share-campaign.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UtilityService } from 'src/app/services/utility.service';
import { UserService } from 'src/app/services/user.service';
import { ResourceService } from 'src/app/services/common/resource.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { IndexedDBService } from 'src/app/services/common/indexedDb.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { catchError, forkJoin, map, Observable, of, switchMap, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService, Theme } from 'src/app/services/theme.service';
import { firstValueFrom } from 'rxjs';

type SocialLinks = {
  website?: string;
  instagram?: string;
  facebook?: string;
  twitter?: string;
  tiktok?: string;
  pinterest?: string;
  linkedin?: string;
  youtube?: string;
  buyonline?: string;
  amazon?: string;
  flipkart?: string;
};
@Component({
  selector: 'app-deal',
  templateUrl: './deal.component.html',
  styleUrls: ['./deal.component.scss']
})
export class DealComponent implements OnInit {

  dealBackgroundColor = 'white';
  private subs = new Subscription();

  readonly NO_IMG = 'assets/img/no-image.png';
  baseurl: string = '';
  user: any;

  queryString = Object();
  hideFilters = false;
  coverUrl!: string;
  coverUrlBust = '';
  storeDetails: any;
  storeEmail: string = ""

  storeId: string | null = null;
  // storeId!: string | null;

  searchModel: any;
  countryList!: any[];
  stateList!: any[];
  cityList!: any[];
  categoryList!: any[];
  allCategoryId!: string;

  stateName: any = "";
  cityName: any = "";
  filteredDetail: any = [];
  item: any;

  pageSize: any = 28;
  pageIndex: any = 1;
  totalRows = 0;
  campaignList: any = [];
  campaignsLoaded = false;
  isLoggedIn = false;
  ID: any = "";
  brandName!: string;
  logoImg!: string;
  resource: any = {};
  organizationId!: string;
  slug!: string;

  promotions: any[] = [];
  featuredList: any[] = [];
  catalogueList: any[] = [];
  curatedIds: string[] = [];
  // activeTab: string = 'featured'; // default value

  // currentTab: 'featured' | 'promotions' = 'featured';
  // showFeatured = false;
  // hasTabFromUrl = false;

  smsUrl: string = '';
  wpImage = 'assets/img/wp.png';
  whatsappURL = 'https://wa.me/';
  upiImg = 'assets/img/bhim.png';
  upi_id = '';
  VPA_REGEX = /^[\w.\-]{2,256}@[A-Za-z]{2,64}$/;
  social: any = {};
  userName = 'John Doe';
  designation = 'Sales Manager';
  vcardText = '';
  vcard = 'assets/img/vCard.png';
  links: any

  waNumber = '';
  waMessage = '';
   catalogueBusinessId: string = '';

  owlCardOptions = {
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    items: 1,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
  };


  dealsDetailsImageSlides: OwlOptions = {
    items: 1,
    nav: false,
    loop: true,
    dots: false,
    dotsData: false,  // <-- use custom dots
    autoplay: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    autoplayHoverPause: true,

    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 }
    },
    // autoHeight: false,
  };

  searchType: any[] =
    [
      { text: "All", value: "All" },
      { text: "Brand", value: "Brand" },
      { text: "Category", value: "Category" },
      { text: "Item", value: "Product" },
      { text: "Stores", value: "Stores" }
    ];

  searchForm!: FormGroup;
  showDefault!: boolean;
  productOrRow!: any;
  activeLinks!: any;

  showUpi!: boolean;
  isMobileView: boolean = false;
  campaignData: any;
  // @HostListener('window:resize')
  // get f() { return this.searchForm.controls; }
  get f() {
    return this.searchForm.controls;
  }

  @HostListener('window:resize')
  onResizeWindow() {
    this.onResize();
  }

  constructor(private campaignsService: CampaignsService,
    private userInfoService: UserInfoService,
    private storageService: StorageService,
    private userService: UserService,
    private wishListService: WishListService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private utilityService: UtilityService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private resourceService: ResourceService,
    private router: Router,
    private indexedDbService: IndexedDBService,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private themeService: ThemeService,
  ) {
    this.activatedRoute.data.subscribe(({ data }) => {
      console.log("data", data)
      if (data.data) {
        this.organizationId = data.data;
        this.slug = activatedRoute.snapshot.paramMap.get('slug')!;
        this.storeId = activatedRoute.snapshot.paramMap.get('storeId');
        userInfoService.orgId.next({ id: this.organizationId, slug: this.slug });
      }
    })
  }

  async ngOnInit() {
    this.storageService.storageSubject.subscribe(response => {
      this.setGlobalSearchForm();
    });
    this.subs.add(
      this.themeService.theme$.subscribe((t: Theme) => {
        this.dealBackgroundColor = (t === 'light') ? 'white' : 'black';
      })
    );
    this.loadResoruce();
    this.resourceService.languageSubject.subscribe(response => {
      this.resource = response;
    });
    this.resourceService.languageSubject.subscribe(r => this.resource = r);
    this.baseurl = environment.shareUrl;
    this.isLoggedIn = this.userInfoService.getLoginFlag();

    this.buildForm();
    await this.getCategoryList();
    await this.getCountryList();
    this.baseurl = environment.shareUrl;

    this.queryString = this.activatedRoute.snapshot.queryParams;
    console.log("queryString", this.queryString)
    console.log("this.queryString?.searchParam", this.queryString?.searchParam)

    const pathStoreId = this.activatedRoute.snapshot.paramMap.get('storeId');
    this.storeId = pathStoreId || this.queryString?.storeId || this.storeId || null;


    // Hide filters when we’re on org/store scoped page (your promotions/featured tabs)
    this.hideFilters = !!(this.queryString?.organizationId || this.queryString?.storeId || this.organizationId);

    if (this.queryString?.searchParam) {
      this.searchModel = JSON.parse(window.atob(this.queryString.searchParam));
      this.f.search.setValue(this.searchModel.search);
      this.f.searchBy.setValue(this.searchModel.searchBy);
      this.f.categoryId.setValue(this.searchModel.categoryId);
    }


    if (this.queryString?.organizationId || this.organizationId) {
      this.ID = this.queryString.organizationId ?? this.organizationId;
      // localStorage.setItem("organizationId", this.ID)
      this.userService.getUser(this.ID).subscribe(result => {
        // if(result.data){
        if (result.data) {
          this.loadUserDetail2(this.ID, result.data)

        }
      }
        // }
      )
      this.userService.get_business_user_name(this.ID).subscribe(res => {
        console.log("res", res)
        if (res.data) {
          this.brandName = res.data.name;
          this.logoImg = res.data.logo;
          this.cdRef.detectChanges();
        }
      });
    }

    if (this.queryString?.storeId) {
      this.ID = this.queryString.storeId;
      this.f.searchBy.setValue('Stores');
      this.userService.get_store_user_name(this.ID).subscribe({
        next: res => {
          if (res.data) {
            this.brandName = res.data.stoName;
            this.logoImg = res.data.stoLogo;
            this.catalogueBusinessId = res.data.organizationId || res.data.businessId || this.ID;
            this.cdRef.detectChanges();
          }
          this.loadDealData();
        },
        error: () => {
          this.loadDealData();
        }
      });
    }
    // if (this.queryString?.storeId) {
    //   this.ID = this.queryString.storeId;

    //   this.f.searchBy.setValue('Stores');
    //   this.userService.get_store_user_name(this.ID).subscribe(res => {
    //     if (res.data) {
    //       this.brandName = res.data.stoName;
    //       this.logoImg = res.data.stoLogo;
    //       console.log('social ->', this.social);
    //       this.cdRef.detectChanges();
    //     }
    //   });
    // }

    await this.setGlobalSearchForm();

    // this.loadDealData();

    if (!this.queryString?.storeId) {
      this.loadDealData();
    }
    //   this.activatedRoute.queryParamMap.subscribe(q => {
    //       const tab = (q.get('tab') === 'promotions') ? 'promotions' : 'featured';
    //       this.currentTab = tab;
    //       this.showFeatured = (tab !== 'promotions');

    //       // keep the hide/show decision in sync
    //       this.hideFilters = !!(q.get('organizationId') || q.get('storeId') || this.organizationId);

    //       this.searchForm.patchValue(
    //           { isFeatured: tab !== 'promotions', isDefault: tab === 'featured' },
    //           { emitEvent: false }
    //       );
    //   }
    // );
    // this.coverUrlBust = this.withCacheBust(this.coverUrl);
    //  this.storeDetails = this.backToStoreDeals(this.storeId);

    this.coverUrlBust = this.coverUrl ? this.withCacheBust(this.coverUrl) : '';
    this.checkDevice();

    const params = this.activatedRoute.snapshot.queryParams;

    if (params['wishlist']) {

      //const data = JSON.parse(atob(params['wishlist']));
      if (params['storeEmail']) { this.storeEmail = params['storeEmail']; }
      const data = JSON.parse(decodeURIComponent(atob(params['wishlist'])));
      console.log(`data from redirect url: ${JSON.stringify(data)}`);
      this.onClickWishList(data);
    }

  }
  onResize() {
    this.checkDevice();
    this.cdRef.detectChanges()
  }
  checkDevice() {
    this.isMobileView = window.innerWidth <= 768; // adjust breakpoint if needed
  }
  // switchTab(view: 'featured' | 'promotions') {
  //     this.currentTab = view;
  //     this.showFeatured = (view !== 'promotions');

  //     this.searchForm.patchValue(
  //         { isFeatured: view !== 'promotions', isDefault: view !== 'promotions' },
  //         { emitEvent: false }
  //     );

  //     this.router.navigate([], {
  //         relativeTo: this.activatedRoute,
  //         queryParams: { tab: view },
  //         queryParamsHandling: 'merge'
  //     });
  // }


  // loadDealData() {
  //     this.utilityService.getProductDetails(this.ID).subscribe(result => {
  //         this.featuredList = result.data
  //         // this.userService.featuredList=result.data;

  //         console.log("this.featuredList", this.featuredList)
  //         // console.log("result", result)
  //     })
  // }

  //     ngOnChanges() {
  //   setTimeout(() => {
  //     window.dispatchEvent(new Event('resize'));
  //   }, 100);
  // }
  openShareDialog(templateRef: TemplateRef<any>, event: MouseEvent, item?: any) {
    event?.preventDefault();

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const padding = 12;

    const desiredWidth = 178;
    const widthPx = Math.min(desiredWidth, vw - padding * 2);

    if (vw <= 480) {
      this.dialog.open(templateRef, {
        data: item,
        width: '100vw',
        maxWidth: '100vw',
        panelClass: ['share-dialog', 'share-dialog--bottom'],
        hasBackdrop: true,
        autoFocus: false,
        restoreFocus: false,
        position: { left: '0', bottom: '0' }
      });
      return;
    }


    const x = event.clientX;
    const y = event.clientY;
    const estimatedHeight = 80;

    const left = Math.min(vw - widthPx - padding, x + 12);
    const top = Math.min(vh - estimatedHeight - padding, Math.max(padding, y - estimatedHeight / 25));

    this.dialog.open(templateRef, {
      width: `${widthPx}px`,
      maxWidth: '95vw',
      panelClass: 'share-dialog',
      hasBackdrop: true,
      autoFocus: false,
      restoreFocus: false,
      position: { left: `${left}px`, top: `${top}px` },
    });
  }

  loadDealData() {
    if (this.storeId !== null) {

      const storeId: string = this.storeId;

      // forkJoin({
      //   curated: this.utilityService.getCuratedList(storeId),
      //   catalogue: this.utilityService.getCatalogue(this.ID, storeId)
      // }).subscribe(({ curated, catalogue }: any) => {
      // this.utilityService.getCatalogue(this.ID, storeId).subscribe((res: any) => {
      this.utilityService.getCatalogue(this.catalogueBusinessId || this.ID, storeId).subscribe((res: any) => {
        const list = Array.isArray(res?.data)
          ? res.data.map((el: any) => ({
            ...(el.products || el),
            count: el.count || 0
          }))
          : [];

        this.catalogueList = list.map((p: any) => {
          const raw = Array.isArray(p?.productImages) ? p.productImages : [];
          const pics = raw.filter((x: any) => x && typeof x.src === 'string' && x.src.trim());
          return {
            ...p,
            productImages: pics.length ? pics : [{ src: this.NO_IMG }]
          };
        });

        // Try curated filter — if endpoint exists use it, else show all catalogue
        this.utilityService.getCuratedList(storeId).pipe(
          catchError(() => of({ data: [] }))
        ).subscribe((curated: any) => {
          this.curatedIds = curated?.data || [];
          this.applyCuratedFilterSafe();
        });

      });
    }

    //    if (this.storeId !== null) {

    //   const storeId: string = this.storeId; // ✅ narrowed to string

    // this.utilityService.getCuratedList(storeId).subscribe(res => {
    //   this.curatedIds = res?.data || [];
    //    // IMPORTANT: run filter AFTER catalogue is already loaded
    //   setTimeout(() => {
    //     this.applyCuratedFilterSafe();
    //   }, 0);

    //   // this.loadCatalogueAndBuildFeatured(storeId);
    // });

    //       this.utilityService.getCatalogue(this.ID, this.storeId).subscribe(res => {
    //         console.log('CATALOGUE API RESPONSE', res);
    // console.log('CATALOGUE DATA', res?.data);
    //         console.log('ID', this.ID);
    // console.log('storeId', this.storeId);
    // console.log('router.url', this.router.url);
    // console.log('queryParams', this.activatedRoute.snapshot.queryParams);
    //         // const list = Array.isArray(res?.data) ? res.data.map((el: any) => {
    //         //   console.log('CATALOGUE FULL RESPONSE', JSON.stringify(res, null, 2));
    //         //   return {
    //         //     ...el.products,
    //         //     count: el.count()
    //         //   }
    //         // }) : [];
    //         const list = Array.isArray(res?.data)
    //   ? res.data.map((el: any) => ({
    //       // console.log('CATALOGUE FULL RESPONSE', JSON.stringify(res, null, 2));
    //       ...(el.products || el),
    //       count: el.count || 0
    //     }))
    //   : [];
    //         this.featuredList = list.map((p: any) => {
    //                   console.log("featuredList", this.featuredList)
    //           const raw = Array.isArray(p?.productImages) ? p.productImages : [];
    //           const pics = raw.filter((x: any) => x && typeof x.src === 'string' && x.src.trim());
    //           return {
    //             ...p,
    //             productImages: pics.length ? pics : [{ src: this.NO_IMG }]
    //           };
    //         }
    //         );
    //       })
    //     } 
    else {
      this.utilityService.getProductDetails(this.ID).subscribe(res => {
        const list = Array.isArray(res?.data) ? res.data : [];
        this.featuredList = list.map((p: any) => {
          const raw = Array.isArray(p?.productImages) ? p.productImages : [];
          const pics = raw.filter((x: any) => x && typeof x.src === 'string' && x.src.trim());
          return {
            ...p,
            productImages: pics.length ? pics : [{ src: this.NO_IMG }]
          };
        }
        );
      });
    }
  }

  private loadCatalogueAndBuildFeatured(storeId: string): void {
    this.utilityService.getCatalogue(this.ID, storeId).subscribe(res => {
      const catalogue = Array.isArray(res?.data) ? res.data : [];

      this.catalogueList = catalogue.map((el: any) => ({
        ...(el.products || el),
        count: el.count || 0
      }));

      this.mapCuratedWithCatalogue();
    });
  }

  loadResoruce() {
    this.resourceService.loadResoruce().subscribe(
      response => {
        this.resource = response;
      });
  }

  buildForm(): void {
    this.searchForm = this.formBuilder.group({
      search: [''],
      country: [''],
      state: [''],
      city: [''],
      searchBy: ['All'],
      categoryId: [''],
      isFeatured: [false],
      isDefault: [false]
    });
  }

  async setGlobalSearchForm() {
    let searchData = this.storageService.getGlobalSearch();
    this.f.country.setValue(searchData?.countryId ?? '');
    if (searchData?.countryId && searchData?.stateId) {
      forkJoin([this.utilityService.getStatesList(searchData?.countryId), this.utilityService.getCityList(searchData?.stateId)]).pipe(take(1)).subscribe((result: any) => {
        this.stateList = result[0] ? result[0]?.data : [];
        this.cityList = result[1] ? result[1]?.data : [];

        this.f.state.setValue(searchData?.stateId);
        if (this.stateList) {
          let state = this.stateList.find(x => x.id == this.f.state.value);
          if (state) {
            this.stateName = state.name;
          }
          else {
            this.stateName = '';
          }
        }

        this.f.city.setValue(searchData?.cityId);

        if (this.cityList) {
          let city = this.cityList.find(x => x.id == this.f.city.value);
          if (city) {
            this.cityName = city.name;
          }
          else {
            this.cityName = '';
          }
        }

        this.getCampaignList();
      })
    }
    else {
      this.stateList = [];
      if (searchData?.countryId) {
        await this.getStateList(searchData?.countryId);
      }
      this.cityList = [];
      this.stateName = '';
      this.cityName = '';

      this.f.state.setValue('');
      this.f.city.setValue('');

      this.getCampaignList();
    }
  }

  async getCountryList() {
    this.countryList = await this.indexedDbService.getCountries();
  }

  async getStateList(countryId: any) {
    const res: any = await firstValueFrom(
      this.utilityService.getStatesList(countryId)
    );

    if (res.success) {
      this.stateList = res.data;
    }
    // this.utilityService.getStatesList(countryId).toPromise().then((res: any) => {
    //   if (res.success) {
    //     this.stateList = res.data;
    //   }
    // })
  }

  async getCityList(stateId: any) {
    const res: any = await firstValueFrom(
      this.utilityService.getCityList(stateId)
    );

    if (res.success) {
      this.cityList = res.data;
    }
  }  // async getCityList(stateId: any) {
  //   this.utilityService.getCityList(stateId).toPromise().then((res: any) => {
  //     if (res.success) {
  //       this.cityList = res.data;
  //     }
  //   })
  // }

  async getCategoryList() {
    this.utilityService.getCategory().subscribe((response: any) => {
      if (response.success) {
        this.categoryList = response.data;
        this.allCategoryId =
          this.categoryList?.find(el => el.code == 'ALL')?.id;

        this.f.categoryId.setValue(this.allCategoryId);
      }
    });
  }
  // async getCategoryList() {
  //   await this.utilityService.getCategory().subscribe((response: any) => {
  //     if (response.success) {
  //       this.categoryList = response.data;
  //       this.allCategoryId = this.categoryList?.find(el => el.code == 'ALL')?.id;
  //       this.f.categoryId.setValue(this.allCategoryId);
  //     }
  //   })
  // }

  onChangeState() {
    let state = this.stateList.find(x => x.id == this.f.state.value);
    if (state) {
      this.storageService.setGlobalSearch(StorageKey.globalSearch, "stateId", state.id);
      this.stateName = state.name;
      this.getCityList(state.id)
    }
    else {
      this.stateName = '';
      this.storageService.setGlobalSearch(StorageKey.globalSearch, "stateId", '');
      this.cityList = [];
    }
    this.cityName = '';
    this.f.city.setValue('');
    this.storageService.setGlobalSearch(StorageKey.globalSearch, "cityId", '');
    this.getCampaignList();
  }

  onChangeCity() {
    let city = this.cityList.find(x => x.id == this.f.city.value);
    if (city) {
      this.storageService.setGlobalSearch(StorageKey.globalSearch, "cityId", city.id);
      this.cityName = city.name;
    }
    else {
      this.storageService.setGlobalSearch(StorageKey.globalSearch, "cityId", '');
      this.cityName = '';
    }

    this.getCampaignList();
  }

  getCampaignList() {
    if (!this.ID || this.storeId) {
      console.warn('Campaign API skipped: missing organizationId');
      this.campaignList = [];
      this.totalRows = 0;
      this.campaignsLoaded = true;
      return;
    }
    this.campaignsLoaded = false;


    let countryName = '';
    let country = this.countryList.find(x => x.id == this.f.country.value);
    if (country)// && !this.queryString.storeId && !this.queryString.organizationId) 
      countryName = country.name;
    var filterModel = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      sortColumn: "",
      sortDirection: "",
      search: this.f.searchBy.value == 'All' ? this.f.search.value : '',
      brand: this.f.searchBy.value == 'Brand' ? this.f.search.value : '',
      categoryId: this.f.searchBy.value == 'Category' ? this.f.categoryId.value : this.allCategoryId,
      product: this.f.searchBy.value == 'Product' ? this.f.search.value : '',
      store: this.f.searchBy.value == 'Stores' ? this.f.search.value : '',
      country: countryName,
      state: '', // countryName ? this.stateName : '',
      city: '', // countryName ? this.cityName : '',
    }

    let userType = this.queryString.storeId ? 'store' : '';

    this.campaignsService.list(filterModel, userType, this.ID).subscribe(async (response: any) => {
      this.campaignsLoaded = true;
      if (response.success) {
        this.campaignList = response.data ? response.data : [];
        console.log("this.campaignList", this.campaignList)
        // this.campaignList = this.campaignList.map(obj => ({
        //     ...obj,
        //     products: obj?.campaignImage ? [{ image_url: obj.campaignImage }] : obj.productDetails?.concat(obj.freeProductDetails),
        //     offerDescription: obj.offerDescription,
        //     image: 'assets/img/deals/deals1.jpg',
        //     campaignHeading: this.getCampaignCouponTitle(obj)
        // }));
        // if (this.campaignList.length > 0) {          
        //   this.campaignList = this.campaignList.map((obj:any) => {
        //     let products = obj?.campaignImage
        //       ? [{ image_url: obj.campaignImage }]
        //       : [
        //         ...(obj.productDetails || []).filter((el:any) => el.productImages?.length > 0).map((el:any) => el.productImages.map((e:any) => ({ image_url: e.src }))).flat(),
        //         ...(obj.freeProductDetails || []).filter((el:any) => el.productImages?.length > 0).map((el:any) => el.productImages.map((e:any) => ({ image_url: e.src }))).flat()
        //       ];
        //     if (!products.length) products = [{ image_url: 'assets/img/no-image.png' }]
        //     return {
        //       ...obj,
        //       products,
        //       offerDescription: obj.offerDescription,
        //       image: 'assets/img/deals/deals1.jpg',
        //       campaignHeading: this.getCampaignCouponTitle(obj)
        //     }
        //   });
        // }

        if (this.campaignList.length > 0) {

          forkJoin(
            this.campaignList.map((obj: any) => {

              let products = obj?.campaignImage
                ? [{ image_url: obj.campaignImage }]
                : [
                  ...(obj.productDetails || [])
                    .flatMap((el: any) =>
                      (el.productImages || []).map((e: any) => ({ image_url: e.src }))
                    ),
                  ...(obj.freeProductDetails || [])
                    .flatMap((el: any) =>
                      (el.productImages || []).map((e: any) => ({ image_url: e.src }))
                    )
                ];

              if (!products.length) {
                products = [{ image_url: 'assets/img/no-image.png' }];
              }

              return this.getCampaignCouponTitle2(obj).pipe(
                map(campaignHeading => ({
                  ...obj,
                  products,
                  offerDescription: obj.offerDescription,
                  image: 'assets/img/deals/deals1.jpg',
                  campaignHeading
                }))
              );
            })

          ).subscribe(finalList => {
            this.campaignList = finalList;
            console.log('final campaign list', this.campaignList);
          });
        }

        this.totalRows = response.totalRecords;
        //demo : if promotions is empty
        // this.campaignList = [];
        console.log("this.campaignList----", this.campaignList)
      }
      else {
        this.campaignList = [];
        this.totalRows = 0;
      }
    });
  }

  getCampaignCouponTitle2(obj: any): Observable<string> {
    if (obj.offerType === 'FLAT' || obj.offerType === 'DISCOUNT') {
      return this.campaignsService.detail(obj.campaignId).pipe(
        map(res => {
          const slab = res?.data?.invoiceAmountSlab;
          let value = 0;

          if (Array.isArray(slab) && slab.length) {
            const lastSlab = slab[slab.length - 1];

            if (obj.offerType === 'FLAT') {
              value = Number(lastSlab?.discountAmount ?? lastSlab?.discount ?? 0);
              return `Flat ${obj.currencySymbol}${value} Off`;
            }

            if (obj.offerType === 'DISCOUNT') {
              value = Number(lastSlab?.discountPercentage ?? lastSlab?.discount ?? 0);
              return `Discount ${value}%`;
            }
          }

          return obj.offerType === 'FLAT'
            ? `Flat ${obj.currencySymbol}${obj.couponValue} Off`
            : `Discount ${obj.couponValue}%`;
        })
      );
    }

    return of(obj.offerTypeName || '');
  }

  getCampaignCouponTitle(obj: any): any {
    if (obj.offerType) {
      if (obj.offerType == "BUYGET") {
        return "Buy " + obj.mainProductCount + " Get " + obj.freeProductCount;
      }
      else if (obj.offerType == "FLAT") {
        return "Flat " + obj.currencySymbol + obj.couponValue + " Off";
      }
      else if (obj.offerType == "FREESAM") {
        return obj.offerTypeName;
      }
      else if (obj.offerType == "GIFTVC") {
        return obj.offerTypeName + ' ' + obj.currencySymbol + obj.couponValue;
      }
      else if (obj.offerType == "DISCOUNT") {
      }
      else {
        return obj.offerTypeName;
      }
    }
  }


  onPageChanged(event: any) {
    this.pageIndex = event;
    this.getCampaignList();
  }

  onClickDetail(row: any) {
    if (this.ID || this.organizationId) {
      if (this.organizationId)
        this.router.navigate([`${this.slug}/details`], { queryParams: { campaign: row.campaignId } });
      else if (this.queryString?.organizationId)
        this.router.navigate(['deal/details'], { queryParams: { campaign: row.campaignId, organizationId: this.ID } });
      else if (this.queryString?.storeId)
        this.router.navigate(['deal/details'], { queryParams: { campaign: row.campaignId, storeId: this.ID } });
      else
        // if (this.queryString?.organizationId)
        //     this.router.navigate(['deal/details'], { queryParams: { campaign: row.campaignId, type: 'org', organizationId: this.ID } });
        // else if (this.queryString?.storeId)
        //     this.router.navigate(['deal/details'], { queryParams: { campaign: row.campaignId, type: 'store', storeId: this.ID } });
        // else
        this.router.navigate(['deal/details'], { queryParams: { campaign: this.ID } });
    }
    else
      this.router.navigate(['deal/details'], { queryParams: { campaign: row.campaignId } });
  }

  private bindItem(found: any) {
    this.item = found;
    this.filteredDetail = [found];

    const userId =
      this.item?.userId ||
      this.item?.user ||
      this.item?.ownerId ||
      this.item?.createdBy || null;

    if (userId)
      this.loadUserDetail(userId, this.item);
  }


  absoluteUrl(u?: string) {
    if (!u) return 'assets/img/no-image.png';
    return /^https?:\/\//i.test(u) ? u : `${this.baseurl.replace(/\/$/, '')}/${u.replace(/^\//, '')}`;
  }

  private toUrl(v?: string): string {
    const s = (v || '').trim();
    if (!s) return '';
    if (/^https?:\/\//i.test(s)) return s;
    return `https://${s}`;
  }

  //     getWhatsAppUrl(item: any) {
  //     const waMessage =
  //       `${item.feature_contact_method || ''}\n\n` +
  //       `${item.feature_contact_name || ''}\n` +
  //       `${item.feature_contact_designation || ''}\n` +
  //       `${window.location.href}`;

  //     let phone = String(item?.mobile ?? '').replace(/\D/g, '');
  //     const cc = String(item?.countryCode ?? '').replace(/\D/g, '');

  //     if (cc && !phone.startsWith(cc)) phone = cc + phone;

  //     this.whatsappURL = `https://wa.me/${phone}?text=${encodeURIComponent(waMessage)}`;
  //   }

  getWhatsAppUrl(item: any) {
    const shareUrl = this.getCurrentShareUrl();

    const waMessage =
      `${item?.feature_contact_method || ''}\n\n` +
      `${item?.feature_contact_name || ''}\n` +
      `${item?.feature_contact_designation || ''}\n\n` +
      `${shareUrl}`;

    let phone = String(item?.mobile ?? '').replace(/\D/g, '');
    const cc = String(item?.countryCode ?? '').replace(/\D/g, '');
    if (cc && !phone.startsWith(cc)) {
      phone = cc + phone;
    }

    this.whatsappURL = phone
      ? `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(waMessage)}`
      : `https://api.whatsapp.com/send?text=${encodeURIComponent(waMessage)}`;
  }

  private mapSocialLinks(links: any[]) {
    this.social = {};
    if (!Array.isArray(links)) return;

    for (let i = 0; i < links.length; i++) {
      this.social[links[i].mediaType] = links[i].mediaValue;
    }
  }



  private isMobile(): boolean {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  /** minimal UA helper */
  private isIos(): boolean {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  getSmsUrl(item: any) {
    const shareUrl = this.getCurrentShareUrl();
    const body =
      `${item?.feature_contact_method || ''}\n\n` +
      `${item?.feature_contact_name || ''}\n` +
      `${item?.feature_contact_designation || ''}\n\n` +
      `${shareUrl}`;

    let phone = String(item?.mobile ?? '').replace(/\D/g, '');
    const cc = String(item?.countryCode ?? '').replace(/\D/g, '');
    if (cc && !phone.startsWith(cc)) phone = cc + phone;

    const encoded = encodeURIComponent(body);

    if (phone) {
      const sep = this.isIos() ? '&' : '?';
      this.smsUrl = `sms:${phone}${sep}body=${encoded}`;
    } else {
      this.smsUrl = `sms:?body=${encoded}`;
    }
  }

  openSmsOrFallback(item: any) {
    this.getSmsUrl(item);
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (!isMobile) {
      navigator.clipboard?.writeText(decodeURIComponent(this.smsUrl.split('body=')[1] || ''))
        .then(() => this.snackBar.open('Message copied. Paste it into your SMS app to send.', 'OK', { duration: 3000 }))
        .catch(() => this.snackBar.open('SMS not available — please copy the link manually.', 'OK', { duration: 3000 }));
      return;
    }
    window.location.href = this.smsUrl;
  }

  // getSmsUrl(item: any) {
  //   const shareUrl = this.getCurrentShareUrl();
  //   const body =
  //     `${item.feature_contact_method || ''}\n\n` +
  //     `${item.feature_contact_name || ''}\n` +
  //     `${item.feature_contact_designation || ''}\n\n` +
  //     `${shareUrl}`;

  //   let phone = String(item?.mobile ?? '').replace(/\D/g, '');
  //   const cc = String(item?.countryCode ?? '').replace(/\D/g, '');
  //   if (cc && !phone.startsWith(cc)) phone = cc + phone;

  //   // `sms:` scheme: phone + body when phone exists; else body-only
  //   if (phone) {
  //     this.smsUrl = `sms:${phone}?&body=${encodeURIComponent(body)}`;
  //   } else {
  //     this.smsUrl = `sms:?&body=${encodeURIComponent(body)}`;
  //   }
  // }


  private sanitizePhone(phone?: string, countryCode?: string): string {
    const digits = String(phone || '').replace(/\D/g, '');
    const cc = String(countryCode || '').replace(/\D/g, '');
    if (!digits && !cc) return '';
    return (cc && !digits.startsWith(cc)) ? (cc + digits) : digits;
  }

  private buildWhatsAppUrl(item: any): string {
    const shareUrl = this.getCurrentShareUrl();

    const message =
      `${item?.feature_contact_method || ''}\n\n` +
      `${item?.feature_contact_name || ''}\n` +
      `${item?.feature_contact_designation || ''}\n\n` +
      `${shareUrl}`;

    // clean phone number
    let phone = String(item?.waNumber || item?.mobile || '').replace(/\D/g, '');
    const cc = String(item?.countryCode || '').replace(/\D/g, '');

    if (cc && phone && !phone.startsWith(cc)) {
      phone = cc + phone;
    }

    return phone
      ? `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
      : `https://wa.me/?text=${encodeURIComponent(message)}`;
  }

  // private buildWhatsAppUrl(waNumber?: string, waMessage?: string, countryCode?: string): string {
  //   const phone = this.sanitizePhone(waNumber, countryCode);
  //   const text = waMessage ? encodeURIComponent(waMessage) : '';
  //   if (phone) return `https://api.whatsapp.com/send?phone=${phone}${text ? `&text=${text}` : ''}`;
  //   return `https://api.whatsapp.com/send?text=${text}`;
  // }

  /** prefer actual browser origin (localhost/uat/prod), fallback to environment.shareUrl */
  // private getShareOrigin(): string {
  //   try {
  //     const origin = (window && window.location && window.location.origin) ? window.location.origin.replace(/\/$/, '') : '';
  //     if (origin) return origin;
  //   } catch {}
  //   return (this.baseurl || '').replace(/\/$/, '');
  // }

  private getShareOrigin(): string {
    try {
      const origin = (window && window.location && window.location.origin) ? window.location.origin.replace(/\/$/, '') : '';
      if (origin) return origin;
    } catch { }
    return (environment.shareUrl || '').replace(/\/$/, '');
  }

  /** build full share URL for the current client-side route (keeps hash routing) */
  // private getCurrentShareUrl(): string {
  //   const origin = this.getShareOrigin();
  //   const routeUrl = (this.router && this.router.url) ? this.router.url : (window.location.pathname + window.location.search + window.location.hash);
  //   const usesHash = !!window.location.hash || (this.baseurl || '').includes('#');
  //   return usesHash ? `${origin}#${routeUrl.replace(/^\/?/, '')}` : `${origin}${routeUrl}`;
  // }
  // private getCurrentShareUrl(): string {
  //   const origin = this.getShareOrigin();   // always UAT
  //   const path = this.router.url || '';
  //   return `${origin}#${path.replace(/^\/?/, '')}`;
  //   const routeUrl = (this.router && this.router.url) ? this.router.url : (window.location.pathname + window.location.search + window.location.hash);
  //   const usesHash = !!window.location.hash || (this.baseurl || '').includes('#');
  //   return usesHash ? `${origin}#${routeUrl.replace(/^\/?/, '')}` : `${origin}${routeUrl}`;

  // }
  private getCurrentShareUrl(): string {

    const origin = this.getShareOrigin();

    const routeUrl =
      this.router.url ||
      window.location.pathname +
      window.location.search +
      window.location.hash;

    return `${origin}#${routeUrl.replace(/^\/?/, '')}`;
  }

  private async loadUserDetail(id: string, featuredItem?: any) {

    this.userService.detail(id).subscribe({
      // next: (res) => {
      //   const u = (res && res.data) ? res.data : res;
      next: async (res) => {
        console.log("res", res)
        let u = (res && res.data) ? res.data : res;
        // for (let i = 0; i < links.length; i++) {
        //   u[links[i].mediaType] = links[i].mediaValue

        // }
        //store or register email id
        this.storeEmail = res.data.email || '';
        console.log("u.waNumber", u.waNumber)
        // this.whatsappURL = this.buildWhatsAppUrl(u.waNumber, u.waMessage, u.countryCode);

        // this.waNumber = u.waNumber || '';
        // this.waMessage = u.waMessage || '';
        // this.whatsappURL = this.buildWhatsAppUrl(featuredItem || u);

        this.waNumber = u.waNumber || '';
        this.waMessage = u.waMessage || '';
        if (!this.waNumber || !this.waNumber.trim()) {
          this.whatsappURL = '';
          this.smsUrl = '';
          return; // STOP here
        }

        this.whatsappURL = this.buildWhatsAppUrl(featuredItem || u);
        // this.getSmsUrl(featuredItem || u);


        // const s: SocialLinks = {};
        // const add = (key: keyof SocialLinks, val?: string) => {
        //   const url = this.toUrl(val);
        //   if (url) s[key] = url;
        // };

        // add('website', u.website);
        // add('instagram', u.instagram);
        // add('facebook', u.facebook);
        // add('twitter', u.twitter);
        // add('tiktok', u.tiktok);
        // add('pinterest', u.pinterest);
        // add('linkedin', u.linkedin || u.linkedinUrl);
        // add('youtube', u.youtube);
        // add('buyonline', u.buyonline);
        // add('amazon', u.amazon);
        // add('flipkart', u.flipkart);
        this.user = u;
        this.buildVCard(u)
        // console.log("user detail", s)
        // this.social = s;
        // after existing assignments in loadUserDetail next:
        // this.getWhatsAppUrl(featuredItem || u);
        this.getSmsUrl(featuredItem || u);
        this.upi_id = u.upi_id;
      },
      error: (e) => console.error(e)
    });
  }

  private loadUserDetail2(id: string, featuredItem?: any) {
    console.log("id", id)
    console.log("featuredItem", featuredItem)
    // this.loadUserDetail(id, featuredItem,this.links)
    this.userService.links(id).subscribe({
      next: (res) => {
        console.log("res---", res)
        this.links = (res && res.data) ? res.data : res;
        console.log("this.links", this.links)
        this.prepareLinks(this.links)
        this.loadUserDetail(id, featuredItem)
        // this.social = this.links
      },
      error: (e) => console.error(e)
    });
  }


  private esc(s: string | undefined): string {
    return (s || '').replace(/,/g, '\\,').replace(/\n/g, '\\n');
  }

  private buildVCard(user: any) {
    console.log("user", user);
    const logo = user.company_logo || '';
    const ext = logo ? logo.split('.').pop()?.toLowerCase() : '';

    // const ext = user.company_logo.split('.').pop()?.toLowerCase();
    //   const ext = user.company_logo
    // ? user.company_logo.split('.').pop()?.toLowerCase()
    // : '';

    let type = 'JPEG';
    if (ext === 'png') type = 'PNG';
    if (ext === 'jpg' || ext === 'jpeg') type = 'JPEG';
    const lines = [
      'BEGIN:VCARD',
      'VERSION:4.0',
      'KIND:org',
      `N:${this.esc(user.lastName)};${this.esc(user.firstName)};;;`,
      `FN:${this.esc(`${user.firstName} ${user.lastName}`.trim())}`,
      '',
      user.company ? `ORG:${this.esc(user.company)}` : '',
      user.telephone ? `TEL;TYPE=CELL,VOICE:${user.telephone}` : '',
      user.email ? `EMAIL;TYPE=INTERNET:${user.email}` : '',
      user.website ? `URL:${this.esc(user.website)}` : '',
      '',
      '',
      user.company_logo ? `PHOTO;TYPE=${type};VALUE=URI:${this.esc(user.company_logo)}` : '',
      'END:VCARD'
    ].filter(Boolean);

    this.vcardText = lines.join('\r\n');
    this.cdRef.detectChanges();

  }

  downloadVcard(): void {
    const blob = new Blob([this.vcardText], { type: 'text/vcard;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${('contact')}-${('card')}.vcf`;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.remove();
    }, 1000);
  }

  buildUpiUri(p: string): string {
    const params = new URLSearchParams();
    params.set('pa', p);
    params.set('cu', 'INR');
    return `upi://pay?${params.toString()}`;
  }

  onClickShareCampaign(row: any) {
    let dialogRef = this.dialog.open(ShareCampaignComponent, {
      disableClose: true,
      panelClass: "dialog-responsive",
      // width: '40%',
      data: {
        title: row.campaignName,
        campaignId: row.campaignId,
        campaignName: row.campaignName,
        offerDescription: row.offerDescription,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onClickClaimNow(row: any) {
    let isLoggedIn = this.userInfoService.getLoginFlag();
    const loginRequired = row.signInRequired;
    if (isLoggedIn) {
      let dialogRef = this.dialog.open(CouponGenerateComponent, {
        disableClose: true,
        // width: '40%',
        data: {
          campaignId: row.campaignId,
          isGuest: false,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
    else if (!loginRequired) {
      let dialogRef = this.dialog.open(CouponGenerateComponent, {
        disableClose: true,
        // width: '40%',
        data: {
          campaignId: row.campaignId,
          isGuest: true,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
    else {
      var url = "deal/details?campaign=" + row.campaignId;
      if (this.ID || this.organizationId) {
        if (this.organizationId)
          url = this.slug + "/details?campaign=" + row.campaignId;
        if (this.queryString?.organizationId)
          url = "deal/details?campaign=" + row.campaignId + "&organizationId=" + this.ID;
        if (this.queryString?.storeId)
          url = "deal/details?campaign=" + row.campaignId + "&storeId=" + this.ID;
      }
      this.router.navigate(['login'], { queryParams: { returnUrl: url } });
    }
  }

  getCurrencySymbol(): string {
    const data = localStorage.getItem('globalSearch');
    return data ? JSON.parse(data).currencySymbol : '$';
  }

  getCurrencyName(): string {
    const data = localStorage.getItem('globalSearch');
    return data ? JSON.parse(data).currencyName : 'USD';
  }

  generateMiniCartJson(item: any) {
    const isProduct = !!item.price;
    const isCampaign = !!item.campaignName;

    // Extract product
    const product = isProduct
      ? item
      : item.productDetails?.[0] || {};

    // Build tax array (ALL slabs)
    const taxes = (product.taxPercentageSlab || []).map((tax: any) => ({
      type: tax.taxName,
      rate: tax.percentage,
      inclusive: false
    }));

    // Campaign mapping
    const campaign = isCampaign
      ? {
        id: item.campaignId || item._id,
        name: item.campaignName,
        orgId: item.orgId || 'ORG123'
      }
      : null;

    return {
      id: product._id,
      name: product.name,
      price: product.price || 0,
      qty: 1,
      "currency_symbol": this.getCurrencySymbol(),
      "currency": this.getCurrencyName(),
      tax: taxes.length ? taxes : [
        { type: 'GST', rate: 0, inclusive: true }
      ],
      selectedItem: product.selectedItem || [],
      campaign,
      storeEmail: this.storeEmail || '',
      meta: {
        userPhone: item.userPhone || '9199999999999',
        storePhone: item.storePhone || '',
        hostId: item.hostId || 'onoffer',
        guest: item.guest ?? false,

      }
    };
  }
  onClickWishList(row: any) {

    // if there is no login then first login 
    let isLoggedIn = this.userInfoService.getLoginFlag();
    if (!isLoggedIn) {

      let returnUrl = this.router.url;


      //const encodedWishlist = btoa(JSON.stringify(row));
      const encodedWishlist = btoa(encodeURIComponent(JSON.stringify(row)));
      returnUrl += `&wishlist=${encodedWishlist}&storeEmail=${this.storeEmail}`;
      console.log(`return URL: ${returnUrl}`);



      this.router.navigate(['/login'], {
        queryParams: {
          returnUrl: encodeURIComponent(returnUrl)
        }
      });


      return;
    }

    console.log(`data for the item : ${JSON.stringify(row)}`);
    console.log(`data for the cart : ${JSON.stringify(this.generateMiniCartJson(row))}`);
    let data = this.generateMiniCartJson(row);
    console.log(`data which need to pass for the cart : ${JSON.stringify(data)}`);
    console.log(`data of store : ${JSON.stringify(this.storeDetails)}`);
    window.MiniCart?.add(data);

    // if (this.isLoggedIn) {
    //   var data = {
    // campaignId: row.campaignId,
    //     isActive: !row.isWishList,
    //   }
    //   this.wishListService.add(data).subscribe(async (response: any) => {
    //     if (response.success) {
    //       if (row.isWishList) {
    //         this.alertService.showSuccess(row.campaignName + " " + this.resource.wishlist_remove);
    //       }
    //       else {
    //         this.alertService.showSuccess(row.campaignName + " " + this.resource.wishlist_add);
    //       }
    //       this.campaignList.forEach(element => {
    //         if (element.campaignId == row.campaignId) {
    //           element.isWishList = !row.isWishList
    //         }
    //       });
    //     }

    //     else {
    //       this.alertService.showError(response.message);
    //     }
    //   });
    // }
    // else {
    //   var campaignData = {
    //     campaignId: row.campaignId,
    //     campaignName: row.campaignName,
    //   }

    //   var url = "deal?wishlist=" + btoa(JSON.stringify(campaignData))
    //   this.router.navigate(['login'], { queryParams: { returnUrl: url } });
    // }
  }

  onClickWishListfeatured(row: any) {
    // if (this.isLoggedIn) {
    //   var data = {
    //     campaignId: row.campaignId,
    //     isActive: !row.isWishList,
    //   }
    //   this.wishListService.add(data).subscribe(async (response: any) => {
    //     if (response.success) {
    //       if (row.isWishList) {
    //         this.alertService.showSuccess(row.campaignName + " " + this.resource.wishlist_remove);
    //       }
    //       else {
    //         this.alertService.showSuccess(row.campaignName + " " + this.resource.wishlist_add);
    //       }
    //       this.campaignList.forEach(element => {
    //         if (element.campaignId == row.campaignId) {
    //           element.isWishList = !row.isWishList
    //         }
    //       });
    //     }

    //     else {
    //       this.alertService.showError(response.message);
    //     }
    //   });
    // }
    // else {
    //   var campaignData = {
    //     campaignId: row.campaignId,
    //     campaignName: row.campaignName,
    //   }

    //   var url = "deal?wishlist=" + btoa(JSON.stringify(campaignData))
    //   this.router.navigate(['login'], { queryParams: { returnUrl: url } });
    // }
  }


  onClickClearFilters() {
    if (this.isLoggedIn) {
      let userData = JSON.parse(this.storageService.getValue(StorageKey.currentUser));

      this.storageService.setGlobalSearch(StorageKey.globalSearch, "stateId", userData?.stateId ? userData?.stateId : '');
      this.storageService.setGlobalSearch(StorageKey.globalSearch, "cityId", userData?.cityId ? userData?.cityId : '');

      this.stateName = userData?.state ? userData?.state : '';
      this.cityName = userData?.city ? userData?.city : '';
    }
    else {
      this.storageService.setGlobalSearch(StorageKey.globalSearch, "stateId", '');
      this.storageService.setGlobalSearch(StorageKey.globalSearch, "cityId", '');

      this.stateName = '';
      this.cityName = '';
    }
    if (this.searchModel) {
      this.f.search.setValue(this.searchModel.search);
      this.f.searchBy.setValue(this.searchModel.searchBy);
      this.f.categoryId.setValue(this.searchModel.categoryId);
    }
    else {
      this.f.search.setValue('');
      this.f.searchBy.setValue('All');
      this.f.categoryId.setValue(this.allCategoryId);
    }
    this.storageService.storageSubject.next(this.storageService.getGlobalSearch());
  }
  isExpanded: boolean = false;

  togglePanel() {
    this.isExpanded = !this.isExpanded;
  }

  // loadFeaturedListings() {
  //     this.featuredList = this.campaignList;
  // }

  // onClickViewDetail(id: any) {
  //     const queryParams: any =
  //         this.queryString?.organizationId ? { organizationId: this.ID } :
  //             this.queryString?.storeId ? { storeId: this.ID } :
  //                 {};

  //     // ✅ preserve which tab user is on
  //     if (this.currentTab) queryParams.tab = this.currentTab;


  //     if(this.organizationId) {
  //         this.router.navigate(
  //             [this.slug, 'featured-product-details', id]
  //         );
  //     } else {
  //         this.router.navigate(
  //             ['/deal/featured-product-details', id],
  //             Object.keys(queryParams).length ? { queryParams } : undefined
  //         );
  //     }
  // }

  //     onClickViewDetail(id: any) {
  //   if (this.organizationId) {
  //     this.router.navigate(
  //       [this.slug],
  //       { queryParams: { tab: 'featured' }, queryParamsHandling: 'merge' }
  //     );
  //   } else {
  //     this.router.navigate(
  //       ['/deal/organization'],
  //       {
  //         queryParams: {
  //           organizationId: this.ID,
  //           tab: 'featured'
  //         }
  //       }
  //     );
  //   }
  // }

  onClickViewDetail(id: any) {
    if (this.organizationId) {
      this.router.navigate([this.slug, this.storeId ?? '', 'featured-product-details', id].filter(Boolean));
    } else {
      const queryParams =
        this.queryString?.organizationId ? { organizationId: this.ID } :
          this.queryString?.storeId ? { storeId: this.ID } : undefined;

      this.router.navigate(
        ['/deal/featured-product-details', id],
        Object.keys(queryParams || {}).length ? { queryParams } : undefined
      );
    }
  }

  getImageClass(index: number, j: number): string {
    console.log(typeof index, index)
    if (index < 2) {
      if (j == 1) {
        return 'large-img2'
      } else {
        return 'large-img'
      }
    } else {
      return 'small-img'
    }
    // return index < 2  ? 'large-img' : 'small-img';
  }

  withCacheBust(u: string | null | undefined) {
    if (!u) return '';
    const v = Date.now();
    return `${u}${u.includes('?') ? '&' : '?'}v=${v}`;
  }

  backToStoreDeals(id: string) {
    this.router.navigate(['deal/store'], { queryParams: { storeId: id } });
  }

  onImgErr(ev: Event) {
    const img = ev.target as HTMLImageElement;
    if (img && !img.src.endsWith(this.NO_IMG)) {
      img.src = this.NO_IMG;
    }
  }

  prepareLinks(rawLinks: any[]) {
    this.social = {};
    this.showUpi = false;

    if (!Array.isArray(rawLinks)) return;

    const bucket: Record<string, string[]> = {};

    for (const l of rawLinks) {
      const type = (l.mediaType || '').toLowerCase().trim();
      const value = (l.mediaValue || '').trim();
      if (!type) continue;

      if (!bucket[type]) bucket[type] = [];
      bucket[type].push(value);
    }

    Object.keys(bucket).forEach(type => {
      const values = bucket[type];

      if (values.some(v => !v)) return;

      const value = values[0];

      switch (type) {
        case 'website':
          this.social.website = value.startsWith('http')
            ? value
            : `https://${value}`;
          break;

        case 'facebook':
          this.social.facebook = value;
          break;

        case 'twitter':
          this.social.twitter = value;
          break;

        case 'instagram':
          this.social.instagram = value;
          break;

        case 'linkedin':
          this.social.linkedin = value;
          break;

        case 'youtube':
          this.social.youtube = value;
          break;

        case 'pinterest':
          this.social.pinterest = value;
          break;

        case 'tiktok':
          this.social.tiktok = value.includes('tiktok')
            ? value
            : `https://www.tiktok.com/@${value}`;
          break;

        case 'amazon':
          this.social.amazon = value.includes('amazon')
            ? value
            : `https://www.amazon.in/${value}`;
          break;

        case 'flipkart':
          this.social.flipkart = value.includes('flipkart')
            ? value
            : `https://www.flipkart.com/${value}`;
          break;

        case 'buyonline':
          this.social.buyonline = value.startsWith('http')
            ? value
            : `https://${value}`;
          break;

        case 'upi_id':
          this.showUpi = true;
          break;
      }
    });

    console.log('FINAL SOCIAL (STRICT FIXED):', this.social);
  }

  private buildProductShareUrl(item: any): string {

    const origin = this.getShareOrigin();

    const productId = item.productId || item._id;

    // ORG SLUG ROUTE
    if (this.organizationId && this.slug) {

      const storePart = this.storeId ? `/${this.storeId}` : '';

      return `${origin}#/${this.slug}${storePart}/featured-product-details/${productId}`;
    }

    // DEFAULT ROUTE
    let url = `${origin}#/deal/featured-product-details/${productId}`;

    const params: string[] = [];

    // IMPORTANT
    if (this.organizationId) {
      params.push(`organizationId=${this.organizationId}`);
    }

    if (this.storeId) {
      params.push(`storeId=${this.storeId}`);
    }

    if (params.length) {
      url += `?${params.join('&')}`;
    }

    return url;
  }
  // private buildProductShareUrl(item: any): string {

  //   const origin = this.getShareOrigin();

  //   const productId = item.productId || item._id;

  //   // Organization slug route
  //   if (this.organizationId && this.slug) {

  //     const storePart = this.storeId ? `/${this.storeId}` : '';

  //     return `${origin}#/${this.slug}${storePart}/featured-product-details/${productId}`;
  //   }

  //   // Query param routes
  //   let url = `${origin}#/deal/featured-product-details/${productId}`;

  //   if (this.queryString?.organizationId) {
  //     url += `?organizationId=${this.ID}`;
  //   }

  //   if (this.queryString?.storeId) {
  //     url += `?storeId=${this.ID}`;
  //   }

  //   return url;
  // }

  shareOnFacebook(item: any) {

    const shareUrl = this.buildProductShareUrl(item);

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      '_blank',
      'noopener,noreferrer'
    );
  }
  // shareOnFacebook(item: any) {
  //   const message =
  //     `${item.feature_contact_method || ''}\n\n` +
  //     `${item.feature_contact_name || ''}\n` +
  //     `${item.feature_contact_designation || ''}\n` +
  //     `${window.location.href}`;

  //   let shareUrl: string;
  //   // shareUrl = `${this.baseurl}#/deal/featured-product-details/${item._id}`;
  //   const shareUrl = this.getCurrentShareUrl();
  //   window.open(
  //     `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
  //     '_blank',
  //     'noopener,noreferrer'
  //   );
  // }

  shareOnTwitter(item: any): void {

    const shareUrl = this.buildProductShareUrl(item);

    const text = item.name || '';

    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(text)}`,
      '_blank',
      'noopener,noreferrer'
    );
  }
  // shareOnTwitter(item: any): void {
  //   // let shareUrl = `${this.baseurl}#/deal/featured-product-details/${item._id}`;
  //   const shareUrl = this.getCurrentShareUrl();
  //   const text = `${item.feature_contact_method || ''} ${item.feature_contact_name || ''} ${item.feature_contact_designation || ''}`;
  //   window.open(
  //     `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(text)}`,
  //     '_blank',
  //     'noopener,noreferrer'
  //   );
  // }

  shareOnLinkedIn(item: any): void {

    const shareUrl = this.buildProductShareUrl(item);

    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      '_blank',
      'noopener,noreferrer'
    );
  }
  // shareOnLinkedIn(item: any): void {
  //   // let shareUrl = `${this.baseurl}#/deal/featured-product-details/${item._id}`;
  //   const shareUrl = this.getCurrentShareUrl();
  //   window.open(
  //     `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
  //     '_blank',
  //     'noopener,noreferrer'
  //   );
  // }

  shareOnInstagram(item: any): void {
    // const shareUrl = `${this.baseurl}#/deal/featured-product-details/${item._id}`;
    const shareUrl = this.getCurrentShareUrl();

    navigator.clipboard.writeText(shareUrl).then(() => {
      const snackRef = this.snackBar.open(
        "✅ Link copied! Paste it in your Instagram post, story, or bio.",
        "OK",
        { duration: 2000 }
      );

      setTimeout(() => {
        snackRef.dismiss();

        const ua = navigator.userAgent;

        if (/Android/i.test(ua)) {
          window.location.href =
            "intent://instagram.com/#Intent;package=com.instagram.android;scheme=https;end";
        } else if (/iPhone|iPad|iPod/i.test(ua)) {
          window.location.href = "instagram://app";

          setTimeout(() => {
            window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
          }, 1500);
        } else {
          window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
        }
      }, 500);
    }).catch((err: any) => {
      console.error("Clipboard copy failed:", err);
      this.snackBar.open("❌ Could not copy link. Please copy manually.", "OK", { duration: 2000 });
    });
  }

  copyLink(item?: any) {

    const urlToCopy = item
      ? this.buildProductShareUrl(item)
      : this.getCurrentShareUrl();

    if (navigator.clipboard && navigator.clipboard.writeText) {

      navigator.clipboard.writeText(urlToCopy)
        .then(() => {
          this.snackBar.open('Link copied!', 'OK', { duration: 2000 });
        })
        .catch(() => {
          this.fallbackCopy(urlToCopy, this);
        });

      return;
    }

    this.fallbackCopy(urlToCopy, this);
  }
  // onCopyClick(event: MouseEvent, item?: any) {
  //   event.preventDefault();
  //   this.copyLink(item);
  // }

  // copyLink(item?: any) {
  //   // If you prefer to copy a custom URL based on the item, compute it here.
  //   // For now we strictly copy the current page URL as requested:
  //   const urlToCopy = window.location.href;

  //   // Try modern clipboard API first
  //   if (navigator.clipboard && navigator.clipboard.writeText) {
  //     navigator.clipboard.writeText(urlToCopy)
  //       .then(() => {
  //         this.snackBar.open('✅ Link copied to clipboard!', 'OK', { duration: 2000 });
  //       })
  //       .catch((err) => {
  //         console.warn('navigator.clipboard failed:', err);
  //         this.fallbackCopy(urlToCopy, this);
  //       });
  //     return;
  //   }

  //   // fallback for older browsers
  //   this.fallbackCopy(urlToCopy, this);
  // }
  // copyLink(item?: any) {
  //   const base = (this.baseurl || '').replace(/\/$/, '');
  //   const path = this.router.url || '';
  //   const urlToCopy = `${base}#${path}`;

  //   if (navigator.clipboard && navigator.clipboard.writeText) {
  //     navigator.clipboard.writeText(urlToCopy)
  //       .then(() => this.snackBar.open('Link copied!', 'OK', { duration: 2000 }))
  //       .catch(() => this.fallbackCopy(urlToCopy, this));
  //     return;
  //   }
  //   this.fallbackCopy(urlToCopy, this);
  // }


  fallbackCopy(text: string, ctx: any) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      ctx.snackBar.open('✅ Link copied to clipboard!', 'OK', { duration: 2000 });
    } catch (e) {
      console.warn('execCommand fallback failed', e);
      ctx.snackBar.open('❌ Please copy the link manually: ' + text, 'OK', { duration: 4000 });
    }
    document.body.removeChild(ta);
  }


  // get showUpi(): boolean {
  //   return !!(this.upi_id && this.VPA_REGEX.test(this.upi_id));
  // }

  openUpi(): void {
    const uri = `upi://pay?pa=${this.upi_id}&cu=INR`;
    window.location.href = uri;
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onThemeChanged(theme: Theme) {
    this.dealBackgroundColor = theme === 'light' ? 'white' : 'black';
  }

  // getVisibleProducts(products: any[]) {
  //     return products.slice(0, 11); // only show max 10 slides/dots
  // }

  getVisibleProducts(products: any[] | null | undefined): any[] {
    if (!Array.isArray(products) || products.length === 0) {
      return [{
        image_url: 'assets/img/no-image.png'
      }];
    }
    return products.slice(0, 5);
  }



  get hasWhatsapp(): boolean {
    return !!this.waNumber && this.waNumber.trim().length > 0;
  }

  get hasSms(): boolean {
    return !!this.waNumber && this.waNumber.trim().length > 0;
  }

  get hasVcard(): boolean {
    return !!this.vcardText && this.vcardText.trim().length > 0;
  }

  triggerSparkle(event: Event) {
    const el = event.currentTarget as HTMLElement;

    if (Math.random() > 0.7) {
      el.classList.add('sparkle-active');

      setTimeout(() => {
        el.classList.remove('sparkle-active');
      }, 1000);
    }
  }

  // get hasAnyShare(): boolean {
  //   return (
  //     !!this.whatsappURL ||
  //     !!this.smsUrl ||
  //     !!this.vcardText ||
  //     this.showUpi === true ||
  //     Object.keys(this.social || {}).length > 0
  //   );
  // }
  get hasAnyShare(): boolean {
    return (
      this.showContactActions ||
      this.showUpi === true ||
      Object.keys(this.social || {}).length > 0
    );
  }

  get showContactActions(): boolean {
    // WhatsApp number is the single source of truth
    return this.hasWhatsapp;
  }

  private tryBuildFeaturedList() {
    if (this.catalogueList?.length && this.curatedIds?.length) {
      this.mapCuratedWithCatalogue();
      console.log('Curated IDs:', this.curatedIds);
    }
  }

  private mapCuratedWithCatalogue(): void {
    if (!this.curatedIds.length || !this.catalogueList.length) {
      this.featuredList = [];
      return;
    }

    this.featuredList = this.catalogueList
      .filter(item => this.curatedIds.includes(item.productId || item._id))
      .map(item => ({
        ...item,
        productImages:
          item.productImages?.length
            ? item.productImages
            : [{ src: this.NO_IMG }]
      }));

    console.log('FINAL FEATURED LIST:', this.featuredList);
  }

  private applyCuratedFilterSafe(): void {

    if (!Array.isArray(this.catalogueList)) return;

    // if no curated → show everything
    if (!this.curatedIds?.length) {
      this.featuredList = [...this.catalogueList];
      return;
    }

    const curatedSet = new Set(this.curatedIds.map(String));

    this.featuredList = this.catalogueList.filter(item => {

      const id =
        item.productId ||
        item._id ||
        item.products?.productId ||
        item.products?._id;

      return curatedSet.has(String(id));
    });

    console.log('CURATED FEATURED FINAL:', this.featuredList);
  }

}

